// extracted by mini-css-extract-plugin
export default {"button":"CreateIssueBtn_button__NVhci"};